import React, { createContext, useContext, useState } from 'react';
import { TermsAndConditionsModal, TermsAndConditionsData } from './TermsAndConditionsModal';

export type TermsAndConditionsContextValue = {
  openTermsAndConditions: (termsAndConditions?: TermsAndConditionsData) => void;
};

export const TermsAndConditionsContext = createContext<TermsAndConditionsContextValue | undefined>(undefined);

export const TermsAndConditionsProvider = ({ children }: { children: React.ReactNode }) => {
  const [currentTermsAndConditions, setCurrentTermsAndConditions] = useState<TermsAndConditionsData | undefined>();

  const openTermsAndConditions = (termsAndConditions?: TermsAndConditionsData) => {
    setCurrentTermsAndConditions(termsAndConditions);
  };

  return (
    <TermsAndConditionsContext.Provider value={{ openTermsAndConditions }}>
      {children}
      {currentTermsAndConditions ? (
        <TermsAndConditionsModal
          isOpen
          onClose={() => setCurrentTermsAndConditions(undefined)}
          mainBody={currentTermsAndConditions?.mainBody}
        />
      ) : null}
    </TermsAndConditionsContext.Provider>
  );
};

export const useTermsAndConditions = () => {
  const context = useContext(TermsAndConditionsContext);
  if (context === undefined || context === null) {
    throw new Error('useTermsAndConditions must be used within a TermsAndConditionsProvider');
  }
  return context;
};
